import React, { createContext, useContext, useState, useCallback } from 'react';
import { MOCK_USER } from '../services/mockData.js';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(false);

  const sendOtp = useCallback(async (_phone) => {
    setLoading(true);
    await new Promise(r => setTimeout(r, 900));
    setLoading(false);
    return { success: true };
  }, []);

  const verifyOtp = useCallback(async (phone, otp) => {
    setLoading(true);
    await new Promise(r => setTimeout(r, 1100));
    const clean = otp.replace(/\D/g, '');
    if (clean.length === 6) {
      localStorage.setItem('sevak_token', 'mock-jwt-' + Date.now());
      const u = { ...MOCK_USER, phone };
      setUser(u);
      setLoading(false);
      return { success: true, isNewUser: !u.isProfileComplete };
    }
    setLoading(false);
    return { success: false, error: 'Invalid OTP. Demo ke liye 123456 use karein.' };
  }, []);

  const googleLogin = useCallback(async () => {
    setLoading(true);
    await new Promise(r => setTimeout(r, 900));
    localStorage.setItem('sevak_token', 'mock-google-' + Date.now());
    setUser({ ...MOCK_USER, loginMethod: 'google' });
    setLoading(false);
    return { success: true, isNewUser: false };
  }, []);

  const completeOnboarding = useCallback(async (payload) => {
    setLoading(true);
    await new Promise(r => setTimeout(r, 700));
    setUser(prev => ({ ...prev, ...payload, isProfileComplete: true }));
    setLoading(false);
    return { success: true };
  }, []);

  const updateProfile = useCallback(async (payload) => {
    setUser(prev => ({ ...prev, ...payload }));
    return { success: true };
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    localStorage.removeItem('sevak_token');
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, isAuthenticated: !!user, sendOtp, verifyOtp, googleLogin, completeOnboarding, updateProfile, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
